import { render, staticRenderFns } from "./SelectGreatness.vue?vue&type=template&id=d67ea0ae&scoped=true&"
import script from "./SelectGreatness.vue?vue&type=script&lang=js&"
export * from "./SelectGreatness.vue?vue&type=script&lang=js&"
import style0 from "./SelectGreatness.vue?vue&type=style&index=0&id=d67ea0ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67ea0ae",
  null
  
)

export default component.exports